'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/* global window, location, navigator, ActiveXObject */

var lang = require('zero-lang');

/*
 * @author      : 绝云 (wensen.lws@alibaba-inc.com)
 * @description : 记录各种浏览器相关的版本号
 * @note        : browser only
 */
var nav = navigator || {};
var userAgent = nav.userAgent;
var platform = nav.platform;
var plugins = nav.plugins;
var versions = {};
var detectedPlatform = undefined;
var detectedPlugins = undefined;

function setVerInt(versions, key, strVal) {
    versions[key] = lang.toInteger(strVal);
}
function setVer(versions, str, reg) {
    var matched = str.match(reg);
    if (matched) {
        setVerInt(versions, matched[0].match(/\w*/)[0], matched[1] || 0);
    }
}
function detectPlatform(str) {
    /*
     * @description : detect platform
     * @param       : {string} platformStr, platform defined string.
     * @syntax      : detectPlatform(platformStr)
     * @return      : {string} platform. (mac|windows|linux...)
     */
    if (!str) {
        return;
    }
    var result = lang.lc(str).match(/mac|win|linux|ipad|ipod|iphone|android/);
    return lang.isArray(result) ? result[0] : result;
}
function detectPlugin(arr) {
    /*
     * @description : detect plugins (now flash only)
     * @param       : {array } plugins, plugin list
     * @syntax      : detectPlugin(plugins)
     * @return      : {object} { 'flash' : 0|xx }
     */

    return {
        flash: (function () {
            var flash = undefined,
                v = 0,
                startV = 13;
            if (arr && arr.length) {
                flash = arr['Shockwave Flash'];
                if (flash && flash.description) {
                    v = flash.description.match(/\b(\d+)\.\d+\b/)[1] || v;
                }
            } else {
                while (startV--) {
                    try {
                        new ActiveXObject('ShockwaveFlash.ShockwaveFlash.' + startV);
                        v = startV;
                        break;
                    } catch (e) {}
                }
            }
            return lang.toInteger(v);
        })()
    };
}
function detectVersion(str) {
    /*
     * @description : detect versions
     * @param       : {string} userAgent, window.navigator.userAgent
     * @syntax      : detectVerion(userAgent)
     * @return      : {object} { 'flash' : 0|xx }
     */

    if (!str) {
        return;
    }
    str = lang.lc(str);
    var ieVer = undefined;
    var matched = undefined;
    var result = {};

    // browser result {
    lang.each([/msie ([\d.]+)/, /firefox\/([\d.]+)/, /chrome\/([\d.]+)/, /crios\/([\d.]+)/, /opera.([\d.]+)/, /adobeair\/([\d.]+)/], function (reg) {
        setVer(result, str, reg);
    });
    // }
    // chrome {
    if (result.crios) {
        result.chrome = result.crios;
    }
    // }
    // safari {
    matched = str.match(/version\/([\d.]+).*safari/);
    if (matched) {
        setVerInt(result, 'safari', matched[1] || 0);
    }
    // }
    // safari mobile {
    matched = str.match(/version\/([\d.]+).*mobile.*safari/);
    if (matched) {
        setVerInt(result, 'mobilesafari', matched[1] || 0);
    }
    // }
    // engine result {
    lang.each([/trident\/([\d.]+)/, /gecko\/([\d.]+)/, /applewebkit\/([\d.]+)/, /webkit\/([\d.]+)/, // 单独存储 webkit 字段
    /presto\/([\d.]+)/], function (reg) {
        setVer(result, str, reg);
    });
    // IE {
    ieVer = result.msie;
    if (ieVer === 6) {
        result.trident = 4;
    } else if (ieVer === 7 || ieVer === 8) {
        result.trident = 5;
    }
    // }
    // }
    return result;
}

detectedPlugins = detectPlugin(plugins);
detectedPlatform = detectPlatform(platform) || detectPlatform(userAgent) || 'unknown';

lang.extend(versions, detectVersion(userAgent), detectedPlugins);

module.exports = {
    host: location.host,
    platform: detectPlatform,
    plugins: detectedPlugins,
    userAgent: userAgent,
    versions: versions,
    isWebkit: !!versions.webkit,
    isIE: !!versions.msie,
    isOpera: !!window.opera,
    isApple: detectedPlatform.mac || detectedPlatform.ipad || detectedPlatform.ipod || detectedPlatform.iphone
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-dom/~/zero-bom/utils.js
 ** module id = 50
 ** module chunks = 0
 **/